module.exports = __webpack_public_path__ + "media/images/forms-icons/text-icon-aa3c06b0aef355850e271a6f47b1aaa4.svg";